import React from 'react'
import Aguarde from '../components/Aguarde'
import Mensagem from '../components/Mensagem'
import Protocolo from '../components/Protocolo'
import Narrativa from '../components/Narrativa'
import Contato from '../components/Contato'
import LocalOcorrencia from '../components/LocalOcorrencia'
import DataOcorrencia from '../components/DataOcorrencia'
import PessoasEnvolvidas from '../components/PessoasEnvolvidas'
import Postagens from '../components/Postagens'
import UpLoad from '../components/UpLoad'
import BotaoEnviar from '../components/BotaoEnviar'
import { ProgressBar } from 'react-bootstrap'

export default function App(props) {
    
    if (!props.formularioEmPauta === '') {
        return null
    }

    const renderItem = (item,rotulo,percentual,key) => {

        if (!props.linhaDoTempo) {
            return null;
        }

        let tema = null;
        if (item === props.linhaDoTempo.emPauta) {
            tema = "primary"
        } else if (props.linhaDoTempo[item]) {
            tema = "success"
        } else {  
            tema = "warning"
        }
        
        return (
            <ProgressBar 
                animated
                variant={ tema } 
                now={ percentual } 
                label={ rotulo } 
                key={ key } 
            /> 
        )    
    }

    const renderLinhaDoTempo = () => {
        if (props.formularioEmPauta === '') {
            return null;
        }

        if (props.formularioEmPauta === 'Denuncia') {
            return(
                <ProgressBar>
                    { renderItem("contato","Contato",10,1) }
                    { renderItem("local","Local",9,2) }
                    { renderItem("dataHora","Data",8,3) }
                    { renderItem("envolvidos","Envolvidos",12,4) }
                    { renderItem("narrativa","Narrativa",15,5) }
                    { renderItem("postagens","Postagens",16,6) }
                    { renderItem("enviarArquivos","Arquivos",13,7) }
                    { renderItem("submit","Enviar dados",17,8) }
                </ProgressBar>
            )
        }

        if (props.formularioEmPauta === 'Narrativa') {
            return(
                <ProgressBar>
                    { renderItem("narrativa","Complementação",25,1) }
                    { renderItem("postagens","Postagens",25,2) }
                    { renderItem("enviarArquivos","Enviar arquivos",25,3) }
                    { renderItem("submit","Enviar dados",25,4) }
                </ProgressBar>
            )
        } 

        if (props.formularioEmPauta === 'Protocolo') {
            return(
                <ProgressBar>
                    { renderItem("protocolo","Número do protocolo",25,1) }
                    { renderItem("narrativa","Narrativa da ocorrência",25,2) }
                    { renderItem("postagens","Postagens",10,3) }
                    { renderItem("enviarArquivos","Enviar arquivos",20,4) }
                    { renderItem("submit","Enviar dados",20,5) }
                </ProgressBar>
            )
        }
    }

    if (!props.linhaDoTempo) {
        return null;
    }

    const obterClasse = () => {
        let classe = "border p-4 "
        if (props.formularioEmPauta === '' || 
            props.formularioEmPauta === 'CorrespondenciaEntregue' ||
            props.formularioEmPauta === 'VisualizarProvidencias' ||
            props.formularioEmPauta === 'Login' ||
            props.formularioEmPauta === 'ProvidenciasGestor') {
            classe += 'd-none'
        } else {
            classe += 'd-block'
        }

        return classe;
    }

    return (
        <form 
            id="idAppDenuncia" 
            className={ "container " +  ((props.linhaDoTempo.emPauta !== 'local')? 'formulario' : 'formularioLocal' ) }
            name="contact" 
            data-netlify="true"
        >
            <input type="hidden" name="form-name" value="contact" />
            <Aguarde showSpinner={ props.showSpinner } />
            <fieldset className={ obterClasse() }>
                { renderLinhaDoTempo() }
                <Protocolo 
                    chamador={ props.chamador }
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    iniciarCampos={ props.iniciarCampos }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    setCorrespondenciaEntregue={ props.setCorrespondenciaEntregue } 
                    correspondenciaEntregue={ props.correspondenciaEntregue }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                    complementacao={ props.complementacao } setComplementacao={ props.setComplementacao }
                    showFormulario={ props.showFormulario }
                    anonimato={ props.anonimato } setAnonimato={ props.setAnonimato }
                />
                <Mensagem mensagem={ props.mensagem } />
                <Contato 
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    anonimato={ props.anonimato } setAnonimato={ props.setAnonimato }
                    dadosPessoais={ props.dadosPessoais } setDadosPessoais={ props.setDadosPessoais }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    showDenuncia={ props.showDenuncia } setShowDenuncia={ props.setShowDenuncia }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                />
                <LocalOcorrencia 
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    showFormulario={ props.showFormulario }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    local={ props.local } setLocal={ props.setLocal }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                />
                <DataOcorrencia 
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    dataAcontecimento={ props.dataAcontecimento} setDataAcontecimento={ props.setDataAcontecimento }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                />
                <PessoasEnvolvidas 
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    pessoasEnvolvidas={ props.pessoasEnvolvidas}
                    setPessoasEnvolvidas={ props.setPessoasEnvolvidas }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                />
                <Narrativa 
                    usuarioLogado={ props.usuarioLogado }
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    anonimato={ props.anonimato }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    denuncia={ props.denuncia } setDenuncia={ props.setDenuncia } 
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                />
                <Postagens
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    links={ props.links} setLinks={ props.setLinks }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                />
                <UpLoad 
                    chamador={ props.chamador }                    
                    formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                    anexosDto={ props.anexosDto } setAnexosDto={ props.setAnexosDto }
                    atualizarAnexos={ props.atualizarAnexos} removerAnexos={ props.removerAnexos }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem } 
                />
                <BotaoEnviar
                    chamador={ props.chamador }                    
                    showFormulario={ props.showFormulario }
                    formularioEmPauta={ props.formularioEmPauta}
                    linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo } 
                    denuncia={ props.denuncia } setDenuncia={ props.setDenuncia }
                    dadosPessoais={ props.dadosPessoais } setDadosPessoais={ props.setDadosPessoais }
                    local={ props.local } setLocal={ props.setLocal }
                    setMensagem={ props.setMensagem }
                    dataAcontecimento={ props.dataAcontecimento} setDataAcontecimento={ props.setDataAcontecimento }
                    pessoasEnvolvidas={ props.pessoasEnvolvidas} setPessoasEnvolvidas={ props.setPessoasEnvolvidas }
                    links={ props.links} setLinks={ props.setLinks }
                    anexosDto={ props.anexosDto } setAnexosDto={ props.setAnexosDto }
                    mensagem={ props.mensagem } setMensagem={ props.setMensagem }
                    setCorrespondenciaEntregue={ props.setCorrespondenciaEntregue }
                    setShowSpinner={ props.setShowSpinner }
                    setMensagem={ props.setMensagem }
                    complementacao={ props.complementacao } setComplementacao={ props.setComplementacao }
                    conteudo={ props.conteudo } setConteudo={ props.setConteudo }
                />
            </fieldset>
        </form>
    );
}